import React from 'react';
// Import Router components - Make sure Outlet is included
import { BrowserRouter as Router, Routes, Route, Link, Navigate, Outlet } from 'react-router-dom';
// Import Auth hook
import { useAuth } from './context/AuthContext';
import { FormProvider } from './context/FormContext';

// Import Pages
import LoginPage from './pages/LoginPage';
import RegistrationPage from './pages/RegistrationPage';
import ServiceListPage from './pages/ServiceListPage';
import ApplyPage from './pages/ApplyPage';
import NotFoundPage from './pages/NotFoundPage';
// Import placeholder for Workplace page if you add it
// import WorkplacePage from './pages/WorkplacePage';
import ServicesHomePage from './pages/ServicesHomePage';
import MyWorkplacePage from './pages/MyWorkplacePage';
import HelpPage from './pages/HelpPage';
import ZampassSignInPage from './pages/ZampassSignInPage';
import ZampassHandlerPage from './pages/ZampassHandlerPage';
import ZampassSignOutPage from './pages/ZampassSignOutPage';
import ServicePassportPage from './pages/ServicePassportPage';
import FlowersServicePage from './pages/FlowersServicePage';
import RentalServicePage from './pages/RentalServicePage';
import DocumentUploadPage from './pages/DocumentUploadPage';
import ApplyPageWrapper from './pages/ApplyPageWrapper';

// Import Components
import ProtectedRoute from './components/ProtectedRoute';
import FormRenderer from './components/FormRenderer';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header'; // Import the redesigned Header
import Footer from './components/Footer'; // Import the new Footer component

// Import your CSS
import './App.css';

function App() {
    // Get auth state - needed for conditional rendering in routes
    const { isAuthenticated } = useAuth();

    return (
        <Router>
            {/* Reset scroll position on every navigation */}
            <ScrollToTop />
            {/* Use the imported Header component */}
            <div className="app-layout-container">
                <Header />

                {/* Main content area */}
                <main style={{ padding: '20px' }}>
                    <FormProvider>
                        <Routes>
                            {/* Public Routes */}
                            <Route path="/" element={<ServicesHomePage />} />
                            <Route path="/help" element={<HelpPage />} />

                            <Route path="/services/list" element={<ServiceListPage />} />
                            <Route path="/services" element={<ServicesHomePage />} />
                            <Route path="/company-register" element={<ServicesHomePage />} />

                            {/* Flowers Service Public Route */}
                            <Route path="/apply/3e05d6ef-473d-4c2a-9fd5-747c8beef595" element={<FlowersServicePage />} />
                            <Route path="/apply/b5b2fc14-d85b-4a26-92af-8bf445cbc7d2" element={<RentalServicePage />} />

                            <Route path="/register" element={<RegistrationPage />} />
                            <Route path="/service/:serviceId" element={<ServicePassportPage />} />
                            <Route path="/login" element={
                                // If already authenticated, redirect from login to home
                                isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />
                            }
                            />
                            <Route path="/zampass-signin" element={<ZampassHandlerPage />} />
                            <Route path="/signin-oidc" element={<ZampassSignInPage />} />
                            <Route path="/signout-callback-oidc" element={<ZampassSignOutPage />} />
                            <Route path="/register" element={
                                // If already authenticated, redirect from register to home
                                isAuthenticated ? <Navigate to="/" replace /> : <RegistrationPage />
                            }
                            />

                            {/* Protected Routes */}
                            <Route element={<ProtectedRoute />}>
                                <Route path="/apply/:serviceId" element={<ApplyPageWrapper />} />
                                <Route path="/apply/:serviceId/documents" element={<DocumentUploadPage />} />
                                {/* Add route for My Workplace page */}
                                <Route path="/my-workplace" element={<MyWorkplacePage />} />
                                {/* Add other protected applicant routes here if needed */}
                            </Route>

                            {/* Not Found */}
                            <Route path="*" element={<NotFoundPage />} />
                        </Routes>
                    </FormProvider>
                </main>

                <Footer />
            </div>
        </Router>
    );
}

export default App;